var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParseForm',{ref:"bus",attrs:{"formParams":_vm.formParams,"emit":_vm.emit,"formId":"dataBusiness","opCode":_vm.opCode,"funcKeyUp":_vm.bindKeyUpInterface}})
}
var staticRenderFns = []

export { render, staticRenderFns }